import { render, staticRenderFns } from "./ContractMare.vue?vue&type=template&id=63b30e90&"
import script from "./ContractMare.vue?vue&type=script&lang=js&"
export * from "./ContractMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports